import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashbaordPage from '../../Pages/DashbaordPage';
import Error404 from '../../Pages/Error404';
import PageManagemet from '../../Pages/Workspace/WorkspacePage';
import WorkspacePage from '../../Pages/Workspace/WorkspacePage';
import EnquiryPage from '../../Pages/Workspace/EnquiryPage';
import FollowUpsDuePage from '../../Pages/Workspace/FollowUpsDuePage';
import QuotationPage from '../../Pages/Workspace/QuotationPage';
import InvoicePage from '../../Pages/Workspace/InvoicePage';
import FinancePage from '../../Pages/Workspace/FinancePage';
import ManageServices from '../../Pages/Manage/ManageServices';
import CreateEnquiry from '../../components/Manage/Enquiry/CreateEnquiry';
import UserManage from '../../Pages/Manage/Users/UserManage';
import BankDetailsPage from '../../Pages/Manage/BankDetails/BankDetailsPage';
import ManageLetters from '../../Pages/Manage/ManageLetters/ManageLetters';
import CreateQuotation from '../../components/Manage/Quotation/CreateQuotation';
import EditViewQuotation from '../../components/Manage/Quotation/EditView/EditViewQuotation';
import ProjectsPage from '../../Pages/Workspace/ProjectsPage';
import EmployeesPage from '../../Pages/Manage/Employees/EmployeesPage';
import CreateProjects from '../../components/Manage/Projects/CreateProjects';
import CreateInvoice from '../../components/Manage/Invoice/CreateInvoice';
import ViewInvoice from '../../components/Manage/Invoice/ViewInvoice';
import ProjectMapping from '../../components/Manage/Invoice/ProjectMap/ProjectMapping';
import ExpensePage from '../../Pages/Manage/Expenses/ExpensePage';
import ManageVendors from '../../components/Manage/Vendor/ManageVendors';
import ManagePermission from '../../Pages/Manage/Permission/ManagePermission';
import ListAllAnnouncement from '../../components/Announcements/ListAllAnnouncement';
import LeaveManagement from '../../components/LeaveManagement/DisplayLeave';
import LeaveRequest from '../../components/LeaveRaise/LeaveRequest';
import SalesExecReport from '../../Pages/Workspace/SalesExecReport';
import ProjectTimeline from '../../components/TaskManagement/ProjectTimeline';
import ListProject from '../../components/TaskManagement/ListProject';
import TaskManagement from '../../components/TaskManagement/TaskTracker';
import AssignedTask from '../../components/TaskManagement/AssignedTask';
import MyTask from '../../components/TaskManagement/MyTask';
import AllActions from '../../components/LeaveManagement/AllActions';
import ManageOrganization from '../../Pages/Manage/Organization/ManageOrganization';
import SalaryIssues from '../../components/LeaveManagement/SalaryIssues';
import ManagePO from '../../components/Manage/PurchaseOrder/ManagePO';
import CreatePO from '../../components/Manage/PurchaseOrder/CreatePO';

import ManagePe from '../../components/Manage/Expenses/ProjectExpense/ManageProEx';
import CreateProEx from '../../components/Manage/Expenses/ProjectExpense/CreateProEx';


import ManageUtilityBill from '../../components/Manage/Expenses/UtilityBill/ManageUtilityBill';
import PlReport from '../../components/Reports/PlReport';
import PaymodeViseReport from '../../components/Reports/PaymodeViseReport';
import ManageComplaints from '../../components/Manage/ComplaintRaise/ManageComplaints';
import Configuration from '../../components/Configuration/Configuration';
import CreateEnquiryPage from '../../Pages/Manage/CreateEnquiryPage';
import SalesExecProfile from '../../Pages/Workspace/SalesExecProfile';
import CreateEmployees from '../../Pages/Manage/Employees/CreateEmployees';
import AssignSalesExecutive from '../../Pages/Manage/Employees/AssignSalesExecutive';

import AddSalesTarget from '../../Pages/Manage/Employees/AddSalesTarget';
import SalesTargets from '../../Pages/Workspace/SalesTargets';

import SalesDashboard from '../../Pages/Workspace/SalesDashboard';

import OverviewProject from '../../components/Manage/Projects/OverviewProject';

import ViewProjectOverview from '../../components/Manage/Projects/ViewProjectOverview';

import AddRequirement from '../../components/Manage/Projects/AddRequirement';
import RequirementGatheringDetail from '../../components/Manage/Projects/RequirementGatheringDetail';
import MilestonesList from '../../components/Manage/Projects/MilestonesList';
import AddMilestone from '../../components/Manage/Projects/AddMilestone';

import TasksList from '../../components/Manage/Projects/TasksList';
import AddTask from '../../components/Manage/Projects/AddTask';

import AddMeeting from '../../components/Manage/Meetings/AddMeeting';

import MeetingsList from '../../components/Manage/Meetings/MeetingsList';
import InventoryDashboard from '../../components/Manage/InventoryManagement/Inventorydashboard';
import ProductsItemsDashboard from '../../components/Manage/InventoryManagement/ProductsItemsDashboard';
import SuppliersDashboard from '../../components/Manage/InventoryManagement/SuppliersDashboard';
import AddSupplier from '../../components/Manage/InventoryManagement/AddSupplier';
import AddItem from '../../components/Manage/InventoryManagement/Additem';
import CategoriesDashboard from '../../components/Manage/InventoryManagement/CategoriesDashboard';
import AddCategory from '../../components/Manage/InventoryManagement/AddCategory';
import PurchaseOrdersDashboard from '../../components/Manage/InventoryManagement/PurchaseOrdersDashboard';
import AddPurchaseOrder from '../../components/Manage/InventoryManagement/AddPurchaseOrder';
import GoodsReceiptsDashboard from '../../components/Manage/InventoryManagement/GoodsReceiptsDashboard';
import AddGoodsReceipt from '../../components/Manage/InventoryManagement/AddGoodsReceipt';
import StockTransfersDashboard from '../../components/Manage/InventoryManagement/StockTransfersDashboard';
import AddStockTransfer from '../../components/Manage/InventoryManagement/AddStockTransfer';
import AdjustmentsDashboard from '../../components/Manage/InventoryManagement/AdjustmentsDashboard';
import AddAdjustment from '../../components/Manage/InventoryManagement/AddAdjustment';
import StockCountDashboard from '../../components/Manage/InventoryManagement/StockCountDashboard';
import AddStockCount from '../../components/Manage/InventoryManagement/AddStockCount';
import LowStockAlertDashboard from '../../components/Manage/InventoryManagement/LowStockAlertDashboard';

const allRoutes = [
  { url: "", component: <DashbaordPage /> },
  { url: "/dashboard", component: <DashbaordPage /> },
  { url: "/workspace", component: <WorkspacePage /> },
  { url: "/enquiry", component: <EnquiryPage /> },
  { url: "/quotation", component: <QuotationPage /> },
  { url: "/invoice", component: <InvoicePage /> },
  { url: "/finance", component: <ExpensePage /> }, //FinancePage
  { url: "/manage-services", component: <ManageServices /> },
  { url: "/manage-user", component: <UserManage /> },
  { url: "/manage-bank-data", component: <BankDetailsPage /> },
  { url: "/enquiry/create", component: <CreateEnquiryPage /> },
  { url: "/enquiry/edit/:eqId", component: <CreateEnquiryPage /> },
  { url: "/manage-letter-formats", component: <ManageLetters /> },
  { url: "/quotation/create", component: <CreateQuotation /> },
  { url: "/quotation/edit", component: <EditViewQuotation /> },
  { url: "/manage-employees", component: <EmployeesPage /> },
  { url: "/projects", component: <ProjectsPage /> },
  { url: "/projects/create", component: <CreateProjects /> },
  { url: "/projects/view", component: <CreateProjects /> },
  { url: "/projects/edit", component: <CreateProjects /> },
  { url: "/invoice/create", component: <CreateInvoice /> },
  { url: "/invoice/view", component: <ViewInvoice /> },
  { url: "/invoice-wise-projects", component: <ProjectMapping /> },
  { url: "/manage-expense", component: <ExpensePage /> },
  { url: "/payments", component: <ExpensePage /> },
  { url: "/manage-vendor", component: <ManageVendors /> },
  { url: "/manage-permission", component: <ManagePermission /> },
  { url: "/announcements", component: <ListAllAnnouncement /> },
  { url: "/workforce-management", component: <LeaveManagement /> },
  { url: "/workforce-management/actions", component: <AllActions /> },

  { url: "/configuration", component: <Configuration /> },
{ url: "/enquiry/sales-performance", component: <SalesExecReport /> },
  { url: "/enquiry/follow-ups-due", component: <FollowUpsDuePage /> },

  { url: "/enquiry/sales-performance/:execName", component: <SalesExecProfile /> },
  { url: "/enquiry/my-performance", component: <SalesExecProfile /> },
  { url: "/sales-target", component: <SalesTargets /> },
  { url: "/add-sales-target", component: <AddSalesTarget /> },

  { url: "/workforce-management/actions/add-leave", component: <AllActions /> },
  { url: "/workforce-management/actions/add-salary", component: <AllActions /> },
  { url: "/workforce-management/actions/documentation-upload", component: <AllActions /> },
  { url: "/workforce-management/actions/generate-offerletter", component: <AllActions /> },
  { url: "/workforce-management/actions/attendance-report", component: <AllActions /> },
  { url: "/workforce-management/actions/salary-issues", component: <AllActions /> },


  { url: "/add-employees", component: <CreateEmployees /> },

  { url: "/assign-sales-executive", component: <AssignSalesExecutive /> },

  { url: "/inventory", component: <InventoryDashboard /> },
  { url: "/inventory/products-items", component: <ProductsItemsDashboard /> },
  { url: "/inventory/add-item", component: <AddItem /> },
  { url: "/inventory/edit-item", component: <AddItem /> },
  { url: "/inventory/view-item", component: <AddItem /> },

  { url: "/inventory/categories", component: <CategoriesDashboard /> },
  { url: "/inventory/categories/add-category", component: <AddCategory /> },
  { url: "/inventory/categories/edit-category", component: <AddCategory /> },
  { url: "/inventory/categories/view-category", component: <AddCategory /> },

  { url: "/inventory/suppliers", component: <SuppliersDashboard /> },
  { url: "/inventory/suppliers/add-supplier", component: <AddSupplier /> },
  { url: "/inventory/suppliers/edit-supplier", component: <AddSupplier /> },
  { url: "/inventory/suppliers/view-supplier", component: <AddSupplier /> },

  { url: "/inventory/purchase-orders", component: <PurchaseOrdersDashboard /> },
  { url: "/inventory/purchase-orders/add-purchase-order", component: <AddPurchaseOrder /> },
  { url: "/inventory/purchase-orders/edit-purchase-order", component: <AddPurchaseOrder /> },
{ url: "/inventory/purchase-orders/view-purchase-order", component: <AddPurchaseOrder /> },

  { url: "/inventory/goods-receipts", component: <GoodsReceiptsDashboard /> },
  { url: "/inventory/goods-receipts/add-goods-receipt", component: <AddGoodsReceipt /> },
  { url: "/inventory/goods-receipts/edit-goods-receipt", component: <AddGoodsReceipt /> },
{ url: "/inventory/goods-receipts/view-goods-receipt", component: <AddGoodsReceipt /> },

  { url: "/inventory/stock-transfer", component: <StockTransfersDashboard /> },
  { url: "/inventory/stock-transfer/add-stock-transfer", component: <AddStockTransfer /> },
  { url: "/inventory/stock-transfer/edit-stock-transfer", component: <AddStockTransfer /> },
 { url: "/inventory/stock-transfer/view-stock-transfer", component: <AddStockTransfer /> },

  { url: "/inventory/adjustments", component: <AdjustmentsDashboard /> },
  { url: "/inventory/adjustments/add-adjustment", component: <AddAdjustment /> },
  { url: "/inventory/adjustments/edit-adjustment", component: <AddAdjustment /> },
 { url: "/inventory/adjustments/view-adjustment", component: <AddAdjustment /> },

  { url: "/inventory/stock-count", component: <StockCountDashboard /> },
  { url: "/inventory/stock-count/add-stock-count", component: <AddStockCount /> },
  { url: "/inventory/stock-count/edit-stock-count", component: <AddStockCount /> },
  { url: "/inventory/stock-count/view-stock-count", component: <AddStockCount /> },

  { url: "/inventory/low-stock-alert", component: <LowStockAlertDashboard /> },

  { url: "/sales-dashboard", component: <SalesDashboard /> },

  { url: "/leave-request", component: <LeaveRequest /> },
  { url: "/manage-task", component: <ListProject /> },
  { url: "/project-timeline", component: <ProjectTimeline /> },
  { url: "/manage-task/create-task", component: <TaskManagement /> },
  { url: "/assigned-task", component: <AssignedTask /> },
  { url: "/my-task", component: <MyTask /> },
  { url: "/manage-organization", component: < ManageOrganization /> },
  { url: "/salary-issues", component: <SalaryIssues /> },

  { url: "/purchase-order", component: <ManagePO /> },
  { url: "/purchase-order/create", component: <CreatePO /> },

{ url: "/project-expenses", component: <ManagePe /> },
{ url: "/project-expenses/create", component: <CreateProEx /> },
{ url: "/project-expenses/edit", component: <CreateProEx /> },

  { url: "/overview-project/meetings/add", component: <AddMeeting /> },

  { url: "/overview-project/meetings", component: <MeetingsList /> },

  { url: "/overview-project", component: <OverviewProject /> },

  { url: "/overview-project/view", component: <ViewProjectOverview /> },

  { url: "/requirement-gathering/add", component: <AddRequirement /> },
  { url: "/overview-project/requirement-gathering", component: <RequirementGatheringDetail /> },

  { url: "/overview-project/milestones", component: <MilestonesList /> },
  { url: "/milestones/add", component: <AddMilestone /> },

  { url: "/overview-project/tasks", component: <TasksList /> },
  { url: "/overview-project/tasks/add", component: <AddTask /> },


  { url: "/utility-bills", component: <ManageUtilityBill /> },
  { url: "/finance/reports/p-l", component: <PlReport /> },
  { url: "/finance/reports/pay-mode-vise", component: <PaymodeViseReport /> },
  { url: "/complaint-raise", component: <ManageComplaints /> },
];

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.url}
          element={route.component}
        />
      ))}

      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      {/* Handle 200 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;